import { Row, Col, Skeleton, Tooltip ,message} from "antd";
import { RiUserSearchFill } from "react-icons/ri";
import axios from "axios";
import classes from "../Pages.module.css";
import { useState, useEffect, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { AiFillDelete} from "react-icons/ai"; // Import AiOutlineEdit icon
import { Link } from "react-router-dom";
import { getFormPermissions} from '../../../utils/checkDayPermission';

const Breakdown_details = (props) => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState(null);


  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("Breakdown Feeding", employeeData);
  
  useEffect(() => {
    fetchData();
  }, [employeeData, canDelete, canQuery]);

  const fetchData = () => {
    axios
      .get(employeeData.URL + "/api/v1/breakdown/show/breakdown", {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);
        const newCols = response.data.data.BREAKDOWN.fields.map((col) => ({
          name: col.name,
          title: col.name.split("_").join(" ").toLowerCase(),
        }));

        const updatedColumns = [
          { name: "D", title: "D" },

          { name: "SNO", title: "SNo" },
          ...newCols,
        ];

        setColumns(updatedColumns);

        const updatedRows = response.data.data.BREAKDOWN.rows.map(
          (row, index) => ({
            D: canDelete ?(
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                  <AiFillDelete
                    onClick={(event) => {
                      // Double-check permission before executing delete
                      if (canDelete) {
                      deleteHandler(
                        event,
                        index,
                        response.data.data.BREAKDOWN.rows,
                        row["code"]
                      )
                    }}}
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ): (
              <Tooltip 
                placement="bottom" 
                title={messages.delete}
                color="red"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),

            SNO: index + 1,
            ...row,
          })
        );

        setRows(updatedRows);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const deleteHandler = (event, index, newrows, code1) => {
    if (!canDelete) {
      message.warning(messages.delete || "You don't have permission to delete items.");
      return;
    }
    // Clear rows before making the delete request
    console.log(newrows);
    setRows(null);
    console.log(code1);
    axios
      .delete(
        employeeData.URL +
          "/api/v1/breakdown/show/breakdown/" +
          code1.toString(),
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        // After successful delete, filter out the deleted row
        const rowvals = newrows.filter((row) => row["code"] !== code1);

        // Update rows with the remaining data
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              D:canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>{
                        // Double-check permission before executing delete
                        if (canDelete) {
                        deleteHandler(event, index, rowvals, row["code"])
                      }
                    }}
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V: canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/stock/transaction/dailyIssue-view/" + row["issue_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
      })
      .catch((error) => {
        // In case of an error, restore the previous rows and log the error
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              D: canDelete ?  (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>{
                        // Double-check permission before executing delete
                        if (canDelete) {
                        deleteHandler(event, index, newrows, row["code"])
                      }
                    }}
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/stock/transaction/dailyIssue-view/" + row["issue_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        console.error(error); // Handle and log the error
      });
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>Breakdown Details</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      <Row className={classes["Row"]}>
        <Col lg={19} md={17}></Col>
        <Col className={classes["Col"]} lg={5} md={7}>
        <Tooltip 
            placement="bottom" 
            title={!canAdd ? messages.add : ""}
          >
          <Link to={canAdd?"/production/transaction/breakdown-create":"#"}
          onClick={(e) => !canAdd && e.preventDefault()}
          >
            <button
              className={classes["ProfileButton"]}
              disabled={!canAdd}
              style={{
                opacity: canAdd ? 1 : 0.5,
                cursor: canAdd ? 'pointer' : 'not-allowed'
              }}
              // style={{ fontSize: "20px", color: "#ffffff", width: "100px" }}
            >
              {/* <AiOutlineEdit
                style={{ marginRight: "5px", fontSize: "1.2rem" }}
              /> */}
              <span
                style={{ verticalAlign: "middle", display: "inline-block" }}
              >
                Add
              </span>
            </button>
          </Link>
          </Tooltip> 
        </Col>
      </Row>
      <p></p>
      {rows && columns.length > 0 ? (
        <EmployeeTable data={rows} columns={columns} val={true} />
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default Breakdown_details;
